import NoticeService from "services/NoticeService";
import { call, fork, put, take } from "redux-saga/effects";
import {
  REQ_NOTICE_DETAIL,
  REQ_NOTICE_LIST,
  RES_NOTICE_DETAIL,
  RES_NOTICE_LIST,
  REQ_CHANGE_FILTER,
  RES_CHANGE_FILTER,
} from "./Notice.store";

/********************************************************************************
 *  Generate Function
 ********************************************************************************/
export function* reqNoticeListApi(data: any) {
  console.log(data);
  try {
    const result = yield call(NoticeService.getNoticeList, data);

    yield put({
      type: RES_NOTICE_LIST,
      payload: result,
    });
  } catch (e) {
    console.error(e);
  }
}
export function* reqNoticeDetailApi(data: any) {
  try {
    const result = yield call(NoticeService.getNoticeDetail, data);

    yield put({
      type: RES_NOTICE_DETAIL,
      payload: result,
    });
  } catch (e) {
    console.error(e);
  }
}

export function* reqChangeFilterApi(data: any) {
  try {
    const result = yield call(NoticeService.getNoticeList, data);

    yield put({
      type: RES_CHANGE_FILTER,
      payload: result,
    });
  } catch (e) {
    console.error(e);
  }
}
/********************************************************************************
 *  call
 ********************************************************************************/
export function* watchReqNoticeList() {
  while (true) {
    const { payload } = yield take(REQ_NOTICE_LIST);
    yield call(reqNoticeListApi, payload);
  }
}
export function* watchReqNoticeDetail() {
  while (true) {
    const { payload } = yield take(REQ_NOTICE_DETAIL);
    yield call(reqNoticeDetailApi, payload);
  }
}
export function* watchReqChangeFilter() {
  while (true) {
    const { payload } = yield take(REQ_CHANGE_FILTER);
    yield call(reqChangeFilterApi, payload);
  }
}
/********************************************************************************
 *  watch
 ********************************************************************************/

export default function* () {
  yield fork(watchReqNoticeList);
  yield fork(watchReqNoticeDetail);
  yield fork(watchReqChangeFilter);
}
